/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbCentreGridDto } from './FcbCentreGridDto';
import {
    FcbCentreGridDtoFromJSON,
    FcbCentreGridDtoFromJSONTyped,
    FcbCentreGridDtoToJSON,
} from './FcbCentreGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbCentreGridDtoPaginatedResults
 */
export interface FcbCentreGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbCentreGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbCentreGridDto>}
     * @memberof FcbCentreGridDtoPaginatedResults
     */
    results?: Array<FcbCentreGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbCentreGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbCentreGridDtoPaginatedResults interface.
 */
export function instanceOfFcbCentreGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbCentreGridDtoPaginatedResultsFromJSON(json: any): FcbCentreGridDtoPaginatedResults {
    return FcbCentreGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbCentreGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbCentreGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbCentreGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbCentreGridDtoPaginatedResultsToJSON(value?: FcbCentreGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbCentreGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

